<template>
  <div id="hygr">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'hygr'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/member/manage/person/Hygr.vue